import { render, staticRenderFns } from "./SchoolBaseSearch.vue?vue&type=template&id=6e53bcc2&scoped=true&"
import script from "./SchoolBaseSearch.vue?vue&type=script&lang=js&"
export * from "./SchoolBaseSearch.vue?vue&type=script&lang=js&"
import style0 from "./SchoolBaseSearch.vue?vue&type=style&index=0&id=6e53bcc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e53bcc2",
  null
  
)

export default component.exports